<template>
  <aside class="l-sp-menu" :class="{active: $store.getters['spMenu/getActiveMenu'] === true}">
    <nav class="search-wrap">
      <p class="side-sub-title">詳しくしぼる</p>
      <div class="user-info">
        <img v-show="this.getItem('access_token')" :src="$store.getters['user/getAvatar']" class="user-avatar">
        <span class="user-name" v-show="this.getItem('access_token')">{{ $store.getters['user/getUserName'] }}</span>
      </div>
      <ul class="checkbox-wrap">
        <li v-for="(menu, index) in sideMenu" :key="index">
          <p class="custom-checkbox">
            <label>
              <input type="checkbox" :value="menu" v-model="searchWord" @change="search()" />
              <span class="item checked-red"><span>{{ menu }}</span></span>
            </label>
          </p>
        </li>
      </ul>

    </nav>

    <nav class="mypage-wrap">
    <p v-show="$store.getters['user/getAccessToken']" class="side-sub-title">マイページ</p>
      <ul v-show="$store.getters['user/getAccessToken']" class="mypage-link-wrap">
        <li class="mypage-link-list"><a href="javascript:void(0)">アカウント</a></li>
        <li class="mypage-link-list"><a href="javascript:void(0)">設定</a></li>
        <li class="mypage-link-list"><a href="javascript:void(0)">ヘルプ</a></li>
      </ul>
    </nav>
  </aside>
</template>

<script>
import utils from '../../../utils/vue/Utils'
import storage from '../../../utils/vue/LocalStorage'

export default {
  name: 'comp-side-menu',
  data () {
    return {
      triggerActive: false,
      sideMenu: ['大使館', 'ショッピング', 'ファッション', '学校', 'スタジオ', 'イベント', '神社', '待ち合わせ'],
      searchWord: [],
      facebook: {
        FB: {},
        model: {},
        appId:
          process.env.NODE_ENV === 'development'
            ? '1011819239015324'
            : '1554981731355750'
      }
    }
  },
  methods: {
    search () {
      let searchWord = ''
      this.searchWord.forEach(word => {
        searchWord += searchWord === '' ? word : ' ' + word
      })
      this.store.dispatch('search/setSearchWord', searchWord)
      this.getMarkerCoordinates()
    },
    handleSdkInit ({ FB }) {
      this.facebook.FB = FB
    },
    handleFbConnect () {
      let ref = this
      this.facebook.FB.getLoginStatus((response) => {
        // If connected and did not login to GeoMark
        if (response.status === 'connected' && !this.getItem('user_id')) {
          ref.onLoginSuccess(response)
        } else {
          ref.restoreSession()
        }
      })
    },
    onLoginSuccess (response) {
      this.postUserApi('auth/login', response).then((res) => {
        let {user, session} = res.data
        this.setItem('user_id', user.id)
        this.setItem('user_name', user.name)
        this.setItem('user_avatar', user.picture_large)
        this.setItem('access_token', session.access_token)
        this.setItem('fb_access_token', response.authResponse.accessToken)

        this.store.dispatch('user/setUserID', user.id)
        this.store.dispatch('user/setUserName', user.name)
        this.store.dispatch('user/setAccessToken', session.access_token)
        this.store.dispatch('user/setFbAccessToken', response.authResponse.accessToken)
        this.store.dispatch('user/setAvatar', user.picture_large)
      }).catch((error) => {
        console.error(error)
      })
    },
    handleFbLogout () {
      this.postUserApi('auth/logout', null).then((res) => {
        this.removeItem('user_id')
        this.removeItem('user_name')
        this.removeItem('user_avatar')
        this.removeItem('access_token')
        this.removeItem('fb_access_token')

        this.store.dispatch('user/setUserID', '')
        this.store.dispatch('user/setUserName', '')
        this.store.dispatch('user/setAccessToken', '')
        this.store.dispatch('user/setFbAccessToken', '')
        this.store.dispatch('user/setAvatar', '')
      }).catch((error) => {
        console.error(error)
      })
    },
    restoreSession () {
      this.store.dispatch('user/setUserID', this.getItem('user_id'))
      this.store.dispatch('user/setUserName', this.getItem('user_name'))
      this.store.dispatch('user/setAvatar', this.getItem('user_avatar'))
      this.store.dispatch('user/setAccessToken', this.getItem('access_token'))
      this.store.dispatch('user/setFbAccessToken', this.getItem('fb_access_token'))
    }
  },
  mixins: [storage, utils]
}
</script>

<style lang="scss" scoped src="../scss/CompSideMenu.scss"></style>



// WEBPACK FOOTER //
// src/components/shared/vue/CompSideMenu.vue